import {
  GROUP_LISTE_REQUETTE,
  GROUP_LISTE_SUCCES,
  GROUP_LISTE_ECHEC,
  GROUP_CREATION_REQUETTE,
  GROUP_CREATION_ECHEC,
  GROUP_CREATION_SUCCES,
  GROUP_DETAILS_REQUETTE,
  GROUP_DETAILS_SUCCES,
  GROUP_DETAILS_ECHEC,
} from "../constantes/groupcliConstantes";
import axios from "axios";

//const uri = "https://164.132.56.133:5000";
//const uri = "https://ahmed.prod-manager.tk:5000";
//const uri = "https://localhost:5000";
//const uri = "https://ahmed.prod-manager.tk/back";
//const uri = `https://gestpro.globalsystempro.com/back`;

//const uri = `http://${manifest.debuggerHost.split(":").shift()}:5000`;
import { store } from "../store";
let uri = "";
function changeURi() {
  const cliServ = store.getState().cliServState.cliServ;
  return (uri =
    cliServ != 0
      ? cliServ == "SERV1"
        ? process.env.REACT_APP_SERV_1
        : process.env.REACT_APP_SERV_2
      : process.env.REACT_APP_SERV_1);
}
changeURi();
export const listeGroup = () => async (dispatch) => {
  try {
    dispatch({ type: GROUP_LISTE_REQUETTE });
    const { data } = await axios.get(`${uri}/api/group`);
    dispatch({ type: GROUP_LISTE_SUCCES, payload: data });
  } catch (error) {
    dispatch({
      type: GROUP_LISTE_ECHEC,
      payload: error.response && error.response.data.message,
    });
  }
};
export const creeGroup =
  ({ wcod_group, wlib_group }) =>
  async (dispatch) => {
    try {
      dispatch({ type: GROUP_CREATION_REQUETTE });
      const config = {
        headers: {
          "content-type": "application/json",
        },
      };
      const { data } = await axios.post(
        `${uri}/api/group`,
        { wcod_group, wlib_group },
        config
      );
      dispatch({ type: GROUP_CREATION_SUCCES, payload: data });
    } catch (error) {
      dispatch({
        type: GROUP_CREATION_ECHEC,
        payload: error.response && error.response.data.message,
      });
    }
  };
